import { render } from "./github.svg?vue&type=template&id=ee11601e"
const script = {}
script.render = render

export default script